import { friendApis } from '@apis/friendApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { FriendInvitationsQueryParam } from '@models/Friend';

export const useFriendInvitingList = createUseQuery(
  (query: FriendInvitationsQueryParam) => ['/friend/inviting/', query],
  (query) => () => friendApis.get('/friend/inviting/', { query }).then((r) => r[200]!),
);
